exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".array-list[data-v-16a6f459]{margin-top:10px}.array-item[data-v-16a6f459]{border:1px solid #ebeef5;margin-bottom:10px}.array-item__header[data-v-16a6f459]{display:flex;justify-content:space-between;padding:10px;border-bottom:1px solid #ebeef5}.array-item__content[data-v-16a6f459]{padding:10px}.array-item__footer[data-v-16a6f459]{display:flex;justify-content:center;padding:10px;border-top:1px solid #ebeef5}.array-item__index[data-v-16a6f459]{display:flex;flex-direction:row}.array-item__label[data-v-16a6f459]{width:200px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-16a6f459","scoped":true,"sourceMap":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ArrayListBox/ArrayListBox.vue
// module id = 132
// module chunks = 0